import React, { useEffect, useState } from 'react'
import { ValidatorForm } from 'react-form-validator-core'

import Fields from '@shared/form-fields'

const GCExemptionModify = ({ record, fields, submit, closeModal, tableName }) => {
  const [acList, setAcList] = useState([]);
  const [fridgeList, setFridgeList] = useState([]);
  const [freezerList, setFreezerList] = useState([]);
  const [waterHeaterList, setWaterHeaterList] = useState([]);
  const [walkInFreezerList, setWalkInFreezerList] = useState([]);
  const [walkInFridgeList, setWalkInFridgeList] = useState([]);

  const [newItem, setNewItem] = useState([
    {item_type: 'ac'},
    {item_type: 'fridge'},
    {item_type: 'freezer'},
    {item_type: 'walk_in_fridge'},
    {item_type: 'walk_in_freezer'},
    {item_type: 'water_heater'},
  ])

  const [fridgeQuantity, setFridgeQuantity] = useState(0)
  const [freezerQuantity, setFreezerQuantity] = useState(0)
  const [walkInFridgeQuantity, setWalkInFridgeQuantity] = useState(0)
  const [walkInFreezerQuantity, setWalkInFreezerQuantity] = useState(0)
  const [waterHeaterQuantity, setWaterHeaterQuantity] = useState(0)
  const [airConditionerQuantity, setAirConditionerQuantity] = useState(0)

  const [calcAcQty, setCalcAcQty] = useState(0)
  const [calcFridgeQty, setCalcFridgeQty] = useState(0)
  const [calcFreezerQty, setCalcFreezerQty] = useState(0)
  const [calcWalkInFridgeQty, setCalcWalkInFridgeQty] = useState(0)
  const [calcWalkInFreezerQty, setCalcWalkInFreezerQty] = useState(0)
  const [calcWaterHeaterQty, setCalcWaterHeaterQty] = useState(0)

  // console.log(record)

  // Selectable Array for All models
  const tempOptions = [
    {
      value: 'low temperature',
      label: "Low Temperature (-19 °C to -86 °C)",
    },
    {
      value: 'medium temperature',
      label: "Medium Temperature (-4 °C to -18 °C)",
    },
  ]
  const acMetrics = [
    {
      value: 'SEER',
      label: 'SEER',
    },
    {
      value: 'SEER2',
      label: 'SEER2',
    },
    {
      value: 'CEER',
      label: 'CEER',
    },
  ]

  // Grab model and quantity data from record data
  useEffect(() => {
    setFreezerQuantity(record.freezer_quantity || 0);
    setFridgeQuantity(record.fridge_quantity || 0)
    setWalkInFreezerQuantity(record.walk_in_freezer_quantity || 0)
    setWalkInFridgeQuantity(record.walk_in_fridge_quantity || 0)
    setWaterHeaterQuantity(record.water_heater_quantity || 0)
    setAirConditionerQuantity(record.air_conditioner_quantity || 0)

    const acModels = record.ac_model.map((x, i) => (
      {
        id: parseInt(x.id) || parseInt(i),
        Make: x.Make,
        Model: x.Model,
        'Efficiency Metric': x['Efficiency Metric'],
        efficiency_metric: x['Efficiency Metric'],
        quantity: x.quantity,
        store_purchased: x.store_purchased,
      }
    ))
    setAcList(acModels)

    const fridgeModels = record.fridge_model.map((x, i) => (
      {
        id: parseInt(x.id) || parseInt(i),
        Make: x.Make,
        Model: x.Model,
        kwh_per_year: x.kwh_per_year,
        quantity: x.quantity,
        store_purchased: x.store_purchased,
      }
    ))
    setFridgeList(fridgeModels)

    const freezerModels = record.freezer_model.map((x, i) => (
      {
        id: parseInt(x.id) || parseInt(i),
        Make: x.Make,
        Model: x.Model,
        kwh_per_year: x.kwh_per_year,
        quantity: x.quantity,
        store_purchased: x.store_purchased,
      }
    ))
    setFreezerList(freezerModels)

    const waterHeaterModels = record.water_heater_model.map((x, i) => (
      {
        id: parseInt(x.id) || parseInt(i),
        Make: x.Make,
        Model: x.Model,
        kwh_per_year: x.kwh_per_year,
        quantity: x.quantity,
        store_purchased: x.store_purchased,
      }
    ))
    setWaterHeaterList(waterHeaterModels)

    const walkInFreezersModels = record.walk_in_freezers_model.map((x, i) => (
      {
        id: parseInt(x.id) || parseInt(i),
        Make: x.Make,
        Model: x.Model,
        uef: x.uef,
        quantity: x.quantity,
        store_purchased: x.store_purchased,
      }
    ))
    setWalkInFreezerList(walkInFreezersModels)

    const walkInFridgesModels = record.walk_in_fridges_model.map((x, i) => (
      {
        id: parseInt(x.id) || parseInt(i),
        Make: x.Make,
        Model: x.Model,
        temperature: x.temperature,
        btu_per_hour: x.btu_per_hour,
        quantity: x.quantity,
        store_purchased: x.store_purchased,
      }
    ))
    setWalkInFridgeList(walkInFridgesModels)
  }, [fields, record])

  // Calculate Quantity of models for exemption - Air Conditioners
  useEffect(() => {
    let calcTotal = 0
    acList.forEach(x => {
      calcTotal += parseInt(x.quantity)
    })

    setCalcAcQty(calcTotal)
  }, [acList])

  // Calculate Quantity of models for exemption - Refrigerators
  useEffect(() => {
    let calcTotal = 0
    fridgeList.forEach(x => {
      calcTotal += parseInt(x.quantity)
    })

    setCalcFridgeQty(calcTotal)
  }, [freezerList])

  // Calculate Quantity of models for exemption - Freezers
  useEffect(() => {
    let calcTotal = 0
    freezerList.forEach(x => {
      calcTotal += parseInt(x.quantity)
    })

    setCalcFreezerQty(calcTotal)
  }, [freezerList])

  // Calculate Quantity of models for exemption - Walk-in Fridge
  useEffect(() => {
    let calcTotal = 0
    walkInFridgeList.forEach(x => {
      calcTotal += parseInt(x.quantity)
    })

    setCalcWalkInFridgeQty(calcTotal)
  }, [walkInFridgeList])

  // Calculate Quantity of models for exemption - Walk-in Freezer
  useEffect(() => {
    let calcTotal = 0
    walkInFreezerList.forEach(x => {
      calcTotal += parseInt(x.quantity)
    })

    setCalcWalkInFreezerQty(calcTotal)
  }, [walkInFreezerList])

  // Calculate Quantity of models for exemption - Water Heater
  useEffect(() => {
    let calcTotal = 0
    waterHeaterList.forEach(x => {
      calcTotal += parseInt(x.quantity)
    })

    setCalcWaterHeaterQty(calcTotal)
  }, [waterHeaterList])

  const on = {
    setInput: (val, i, key, model = 'ac', action_type = 'edit') => {
      let newHistory = []

      if(action_type == 'add') {
        newHistory = [...newItem]
        let targetItem = newHistory.find(x => x.item_type == model)
        // console.log('target item:', targetItem)
        targetItem[key] = val
        let filteredHistory = newHistory.filter(x => x.item_type != model)
        newHistory = [...filteredHistory, targetItem]

        setNewItem(newHistory)
        return
      }

      switch (model) {
        case 'ac':
          newHistory = [...acList];
          newHistory[i][key] = val;

          setAcList(newHistory)

          break;
        case 'fridge':
          newHistory = [...fridgeList];
          newHistory[i][key] = val;

          setFridgeList(newHistory)

        break;
        case 'freezer':
          newHistory = [...freezerList];
          newHistory[i][key] = val;

          setFreezerList(newHistory)

        break;
        case 'water_heater':
          newHistory = [...waterHeaterList];
          newHistory[i][key] = val;

          setWaterHeaterList(newHistory)

        break;
        case 'walk_in_freezer':
          newHistory = [...walkInFreezerList];
          newHistory[i][key] = val;

          setWalkInFreezerList(newHistory)

        break;
        case 'walk_in_fridge':
          newHistory = [...walkInFridgeList];
          newHistory[i][key] = val;

          setWalkInFridgeList(newHistory)

        break;
        default:
          break;
      }
    }
  }

  const addItem = (ev, item_type) => {
    ev && ev.preventDefault()

    // console.log('newItem Listings: ', newItem);
    let newHistory = []

    // Grab targeted object out of newItem array of objects using item_type var
    let tempHistory = [...newItem]
    let targetItem = tempHistory.find(x => x.item_type == item_type)
    // console.log('target item:', targetItem)

    //Uncomment to wipe newItem fields clean for relevant exemption item_type after new item addition **\
    const cleanTargetItem = { item_type }
    // Filter out the targeted item and replace with a replica without field data
    let filteredHistory = tempHistory.filter(x => x.item_type != item_type)
    tempHistory = [...filteredHistory, cleanTargetItem]

    setNewItem(tempHistory)
    //**************************************************************************/

    switch (item_type) {
      case 'ac':
        // Assign ID to new item about to be added to exemption listing
        targetItem.id = acList.length
        // console.log('targetItem ID: ', targetItem.id, 'Target Item Details', targetItem)
        newHistory = [...acList, targetItem]

        setAcList(newHistory)
        break;
      case 'fridge':
        // Assign ID to new item about to be added to exemption listing
        targetItem.id = fridgeList.length
        newHistory = [...fridgeList, targetItem]

        setFridgeList(newHistory)
      break;
      case 'freezer':
        // Assign ID to new item about to be added to exemption listing
        targetItem.id = freezerList.length
        newHistory = [...freezerList, targetItem]

        setFreezerList(newHistory)
      break;
      case 'water_heater':
        // Assign ID to new item about to be added to exemption listing
        targetItem.id = waterHeaterList.length
        newHistory = [...waterHeaterList, targetItem]

        setWaterHeaterList(newHistory)
      break;
      case 'walk_in_freezer':
        // Assign ID to new item about to be added to exemption listing
        targetItem.id = walkInFreezerList.length
        newHistory = [...walkInFreezerList, targetItem]

        setWalkInFreezerList(newHistory)
      break;
      case 'walk_in_fridge':
        // Assign ID to new item about to be added to exemption listing
        targetItem.id = walkInFridgeList.length
        newHistory = [...walkInFridgeList, targetItem]

        setWalkInFridgeList(newHistory)
      break;
      default:
        break;
    }
  }

  const removeItem = (model, item) => {
    let newHistory = []
    let newHistoryNewIdOrder = []
    switch (model) {
      case 'ac':
        newHistory = acList.filter(x => x.id != item.id);
        // console.log('model', model, 'item', item)
        // console.log('listing', newHistory)
        // Make sure the id field in the array changes to match the new number of records
        newHistoryNewIdOrder = newHistory.map((x, i) => ({ ...x, id: i + 1 }))

        setAcList(newHistoryNewIdOrder)
        break;
      case 'fridge':
        newHistory = fridgeList.filter(x => x.id != item.id);
        // Make sure the id field in the array changes to match the new number of records
        newHistoryNewIdOrder = newHistory.map((x, i) => ({ ...x, id: i + 1 }))

        setFridgeList(newHistoryNewIdOrder)
      break;
      case 'freezer':
        newHistory = freezerList.filter(x => x.id != item.id);
        // Make sure the id field in the array changes to match the new number of records
        newHistoryNewIdOrder = newHistory.map((x, i) => ({ ...x, id: i + 1 }))

        setFreezerList(newHistoryNewIdOrder)
      break;
      case 'water_heater':
        newHistory = waterHeaterList.filter(x => x.id != item.id);
        // Make sure the id field in the array changes to match the new number of records
        newHistoryNewIdOrder = newHistory.map((x, i) => ({ ...x, id: i + 1 }))

        setWaterHeaterList(newHistoryNewIdOrder)
      break;
      case 'walk_in_freezer':
        newHistory = walkInFreezerList.filter(x => x.id != item.id);
        // Make sure the id field in the array changes to match the new number of records
        newHistoryNewIdOrder = newHistory.map((x, i) => ({ ...x, id: i + 1 }))

        setWalkInFreezerList(newHistoryNewIdOrder)
      break;
      case 'walk_in_fridge':
        newHistory = walkInFridgeList.filter(x => x.id != item.id);
        // Make sure the id field in the array changes to match the new number of records
        newHistoryNewIdOrder = newHistory.map((x, i) => ({ ...x, id: i + 1 }))

        setWalkInFridgeList(newHistoryNewIdOrder)
      break;
      default:
        break;
    }
  }

  const formSubmit = async ev => {
    ev && ev.preventDefault()

    // Remove ID field from criminalFields state array
    const ac_model = acList.map(x => ({ id: x.id, Make: x.Make.trim(), Model: x.Model.trim(), 'Efficiency Metric': x.efficiency_metric, quantity: x.quantity, store_purchased: x.store_purchased.trim() }));
    const fridge_model = fridgeList.map(x => ({ id: x.id, Make: x.Make.trim(), Model: x.Model.trim(), kwh_per_year: x.kwh_per_year, quantity: x.quantity, store_purchased: x.store_purchased.trim() }));
    const freezer_model = freezerList.map(x => ({ id: x.id, Make: x.Make.trim(), Model: x.Model.trim(), kwh_per_year: x.kwh_per_year, quantity: x.quantity, store_purchased: x.store_purchased.trim() }));
    const walk_in_fridges_model = walkInFridgeList.map(x => ({ id: x.id, Make: x.Make.trim(), Model: x.Model.trim(),
                                                               temperature: x.temperature, btu_per_hour: x.btu_per_hour,
                                                               quantity: x.quantity, store_purchased: x.store_purchased.trim() }));
    const walk_in_freezers_model = walkInFreezerList.map(x => ({ id: x.id, Make: x.Make.trim(), Model: x.Model.trim(),
                                                               temperature: x.temperature, btu_per_hour: x.btu_per_hour,
                                                               quantity: x.quantity, store_purchased: x.store_purchased.trim() }));
    const water_heater_model = waterHeaterList.map(x => ({ id: x.id, Make: x.Make.trim(), Model: x.Model.trim(), uef: x.uef, quantity: x.quantity, store_purchased: x.store_purchased.trim() }));
    const submitHistory = {
      ac_model: ac_model.length > 0 ? [JSON.stringify(...ac_model)] : [],
      fridge_model: fridge_model.length > 0 ? [JSON.stringify(...fridge_model)] : [],
      freezer_model: freezer_model.length > 0 ? [JSON.stringify(...freezer_model)] : [],
      walk_in_fridges_model: walk_in_fridges_model.length > 0 ? [JSON.stringify(...walk_in_fridges_model)] : [],
      walk_in_freezers_model: walk_in_freezers_model.length > 0 ? [JSON.stringify(...walk_in_freezers_model)] : [],
      water_heater_model: water_heater_model.length > 0 ? [JSON.stringify(...water_heater_model)] : [],
      air_conditioner_quantity: airConditionerQuantity,
      fridge_quantity: fridgeQuantity,
      freezer_quantity: freezerQuantity,
      walk_in_fridge_quantity: walkInFridgeQuantity,
      walk_in_freezer_quantity: walkInFreezerQuantity,
      water_heater_quantity: waterHeaterQuantity,
    }

    // return console.log('Exemption List\n', submitHistory);
    submit(submitHistory)
  }

  const acModelHeadings = (
    <thead>
      <tr>
        <th>Make</th>
        <th>Model</th>
        <th>Quantity</th>
        <th>Store Purchased</th>
        <th>Efficiency Metric</th>
      </tr>
    </thead>
  )
  const fridgeModelHeadings = (
    <thead>
      <tr>
        <th>Make</th>
        <th>Model</th>
        <th>Quantity</th>
        <th>Store Purchased</th>
        <th>kWh/year</th>
      </tr>
    </thead>
  )
  const walkInModelHeadings = (
    <thead>
      <tr>
        <th>Make</th>
        <th>Model</th>
        <th>Quantity</th>
        <th>Store Purchased</th>
        <th>Temperature</th>
        <th>BTU/hour</th>
      </tr>
    </thead>
  )
  const heaterModelHeadings = (
    <thead>
      <tr>
        <th>Make</th>
        <th>Model</th>
        <th>Quantity</th>
        <th>Store Purchased</th>
        <th>Uniform Energy Factory(UEF)</th>
      </tr>
    </thead>
  )

  const colgroup = (
    <colgroup>
      <col span='1' width='180px'></col>
      <col span='1' width='180px'></col>
      <col span='1' width='140px'></col>
      <col span='1' width='200px'></col>
      <col span='1' width='140px'></col>
      <col span='1' width='140px'></col>
    </colgroup>
  )

  // Generate Empty Table Row </tr> with variable about of Table Data <td/>
  const emptyTableRows = ((rows = 0, item_type = 'ac') => (
    <tr key={item_type + '_empty_'} className='table-default'>
      {(() => {
        const rowArr = []
        for (let i = 0; i < rows; i++) {
          rowArr.push(<td key={i + '_' + item_type}>N/A</td>)
        }

        return rowArr
      })()}
    </tr>
  ))

  const tables = () => {
    // const getRowClass = status => {
    //   switch (status) {
    //     case 'surplus':
    //       return 'table-success'
    //     case 'denied':
    //       return 'table-danger'
    //     case 'local purchase':
    //       return 'table-warning'
    //     default:
    //       return 'table-default'
    //   }
    // }

    const addItemRow = (item_type) => {
      const newHistory = [...newItem]
      const targetItem = newHistory.find(x => x.item_type == item_type)
      return (
        <tr key={item_type + 'add'} className='table-default' style={{backgroundColor: '#fff1b485'}}>
          <td key={item_type + '_make_add'}>
            <Fields.Input
              name='Make'
              value={targetItem?.Make || ''}
              className='form-control'
              onChange={ev => on.setInput(ev.target.value, 0, 'Make', item_type, 'add')}
              // required 
              // validators={['required']}
              // errorMessages={['Please enter a valid make']}
              maxLength={100} />
          </td>
          <td key={item_type + '_model_add'}>
            <Fields.Input
              name='Model'
              value={targetItem?.Model || ''}
              className='form-control'
              onChange={ev => on.setInput(ev.target.value, 0, 'Model', item_type, 'add')}
              // required 
              // validators={['required']}
              // errorMessages={['Please enter a valid model']}
              maxLength={100} />
          </td>
          <td key={item_type + '_qty_add'}>
            <Fields.Input
              icon={'hashtag'}
              name='quantity'
              value={targetItem?.quantity || ''}
              className='form-control'
              onChange={ev => on.setInput(ev.target.value, 0, 'quantity', item_type, 'add')}
              // required 
              // validators={['required']}
              // errorMessages={['Required']}
              type='number'/>
          </td>
          <td key={item_type + '_store_add'}>
            <Fields.Input
              name='store_purchased'
              value={targetItem?.store_purchased || ''}
              className='form-control'
              onChange={ev => on.setInput(ev.target.value, 0, 'store_purchased', item_type, 'add')}
              // validators={['required']}
              // errorMessages={['Required']}
              maxLength={100} />
          </td>
          {item_type == 'ac' && (
            <td key={item_type + '_efficiency_metric_add'}>
              <Fields.NativeSelect
                name='efficiency_metric'
                options={acMetrics}
                value={targetItem?.efficiency_metric || ''}
                onChange={ev => on.setInput(ev.target?.value, 0, 'efficiency_metric', item_type, 'add')}
                className='form-control'
                // required 
                // validators={['required']}
                // errorMessages={['Required']}
                // required
              />
            </td>
          )}
          {(item_type == 'fridge' || item_type == 'freezer') && (
            <td key={item_type + '_kwh_per_year_add'}>
              <Fields.Input
                icon={'hashtag'}
                name='kwh_per_year'
                value={targetItem?.kwh_per_year || ''}
                className='form-control'
                onChange={ev => on.setInput(ev.target.value, 0, 'kwh_per_year', item_type, 'add')}
                // required 
                // validators={['required']}
                // errorMessages={['Please enter a valid number']}
                type='number'
              />
            </td>
          )}
          {(item_type == 'walk_in_fridge' || item_type == 'walk_in_freezer') && (
            <><td key={item_type + '_temperature_add'}>
              <Fields.NativeSelect
                name='temperature'
                options={tempOptions}
                value={targetItem?.temperature || ''}
                onChange={ev => on.setInput(ev.target?.value, 0, 'temperature', item_type, 'add')}
                className='form-control'
                // required 
                // validators={['required']}
                // errorMessages={['Required']}
                // required
              />
            </td>
            <td key={item_type + '_btu_per_hour_add'}>
              <Fields.Input
                icon={'hashtag'}
                name='btu_per_hour'
                value={targetItem?.btu_per_hour || ''}
                className='form-control'
                onChange={ev => on.setInput(ev.target.value, 0, 'btu_per_hour', item_type, 'add')}
                // required 
                // validators={['required']}
                // errorMessages={['Please enter a valid number']}
                type='number'
              />
            </td></>
          )}
          {item_type == 'water_heater' && (
            <td key={item_type + '_uef_add'}>
              <Fields.Input
                icon={'hashtag'}
                name='uef'
                value={targetItem?.uef || ''}
                className='form-control'
                onChange={ev => on.setInput(ev.target.value, 0, 'uef', item_type, 'add')}
                // required 
                // validators={['required']}
                // errorMessages={['Please enter a valid number']}
                type='number'
              />
            </td>
          )}
          <td key={item_type + 'add_button'}>
            <button type='submit' onClick={(ev) => addItem(ev, item_type)} className='btn btn-round btn-info' style={{minWidth: '112px'}}>
              Add
            </button>
          </td>
        </tr>
      )
    }

    const defaultRows = (name, row, i) => {
      return [
        <><td key={name + '_make_' + i}>
          <Fields.Input
            name='Make'
            value={row?.Make}
            className='form-control'
            onChange={ev => on.setInput(ev.target.value, i, 'Make', name)}
            validators={['required']}
            errorMessages={['Please enter a valid make']}
            maxLength={100} />
        </td>
        <td key={name + '_model_' + i}>
          <Fields.Input
            name='Model'
            value={row?.Model}
            className='form-control'
            onChange={ev => on.setInput(ev.target.value, i, 'Model', name)}
            validators={['required']}
            errorMessages={['Please enter a valid model']}
            maxLength={100} />
        </td>
        <td key={name + '_qty_' + i}>
          <Fields.Input
            icon={'hashtag'}
            name='quantity'
            value={row?.quantity}
            className='form-control'
            onChange={ev => on.setInput(ev.target.value, i, 'quantity', name)}
            validators={['required']}
            errorMessages={['Required']}
            type='number'/>
        </td>
        <td key={name + '_store_' + i}>
          <Fields.Input
            name='store_purchased'
            value={row?.store_purchased}
            className='form-control'
            onChange={ev => on.setInput(ev.target.value, i, 'store_purchased', name)}
            validators={['required']}
            errorMessages={['Required']}
            maxLength={100} />
        </td></>
      ]
    }

    const acRows = Array.isArray(acList) && acList.map((row, i) => {
      // console.log(row, i)
      return (
        <tr key={i + '_ac'} className={'table-default'}>
          {defaultRows('ac', row, i)}
          <td>
            <Fields.NativeSelect
              name='efficiency_metric'
              options={acMetrics}
              value={row?.efficiency_metric || ''}
              onChange={ev => on.setInput(ev.target?.value, i, 'efficiency_metric', 'ac')}
              className='form-control'
              // validators={['required']}
              // errorMessages={['Required']}
              // required
            />
          </td>
          <td>
            <button type='button' className='btn btn-round btn-danger' style={{wordBreak: 'normal'}} onClick={() => removeItem('ac', row)}>
              Remove
            </button>
          </td>
        </tr>
      )
    })

    const freezerRows = Array.isArray(freezerList) && freezerList.map((row, i) => {
      return (
        <tr key={i + '_freezer'} className={'table-default'}>
          {defaultRows('freezer', row, i)}
          <td>
            <Fields.Input
              icon={'hashtag'}
              name='kwh_per_year'
              value={row?.kwh_per_year}
              className='form-control'
              onChange={ev => on.setInput(ev.target.value, i, 'kwh_per_year', 'freezer')}
              validators={['required']}
              errorMessages={['Please enter a valid number']}
              type='number'
            />
          </td>
          <td>
            <button type='button' className='btn btn-round btn-danger' style={{wordBreak: 'normal'}} onClick={() => removeItem('freezer', row)}>
              Remove
            </button>
          </td>
        </tr>
      )
    })

    const fridgeRows = Array.isArray(fridgeList) && fridgeList.map((row, i) => {
      return (
        <tr key={i + '_fridge'} className={'table-default'}>
          {defaultRows('fridge', row, i)}
          <td>
            <Fields.Input
              icon={'hashtag'}
              name='kwh_per_year'
              value={row?.kwh_per_year}
              className='form-control'
              onChange={ev => on.setInput(ev.target.value, i, 'kwh_per_year', 'fridge')}
              validators={['required']}
              errorMessages={['Please enter a valid number']}
              type='number'
            />
          </td>
          <td>
            <button type='button' className='btn btn-round btn-danger' style={{wordBreak: 'normal'}} onClick={() => removeItem('fridge', row)}>
              Remove
            </button>
          </td>
        </tr>
      )
    })

    const walkInFridgeRows = Array.isArray(walkInFridgeList) && walkInFridgeList.map((row, i) => {
      return (
        <tr key={i + '_walk_in_fridge'} className={'table-default'}>
          {defaultRows('walk_in_fridge', row, i)}
          <td>
            <Fields.NativeSelect
              name='temperature'
              options={tempOptions}
              value={row?.temperature || ''}
              onChange={ev => on.setInput(ev.target?.value, i, 'temperature', 'walk_in_fridge')}
              className='form-control'
              // validators={['required']}
              // errorMessages={['Required']}
              // required
            />
          </td>
          <td>
            <Fields.Input
              icon={'hashtag'}
              name='btu_per_hour'
              value={row?.btu_per_hour}
              className='form-control'
              onChange={ev => on.setInput(ev.target.value, i, 'btu_per_hour', 'walk_in_fridge')}
              validators={['required']}
              errorMessages={['Please enter a valid number']}
              type='number'
            />
          </td>
          <td>
            <button type='button' className='btn btn-round btn-danger' style={{wordBreak: 'normal'}} onClick={() => removeItem('walk_in_fridge', row)}>
              Remove
            </button>
          </td>
        </tr>
      )
    })

    const walkInFreezerRows = Array.isArray(walkInFreezerList) && walkInFreezerList.map((row, i) => {
      return (
        <tr key={i + '_walk_in_freezer'} className={'table-default'}>
          {defaultRows('walk_in_freezer', row, i)}
          <td>
            <Fields.NativeSelect
              name='temperature'
              options={tempOptions}
              value={row?.temperature || ''}
              onChange={ev => on.setInput(ev.target?.value, i, 'temperature', 'walk_in_freezer')}
              className='form-control'
              // validators={['required']}
              // errorMessages={['Required']}
              // required
            />
          </td>
          <td>
            <Fields.Input
              icon={'hashtag'}
              name='btu_per_hour'
              value={row?.btu_per_hour}
              className='form-control'
              onChange={ev => on.setInput(ev.target.value, i, 'btu_per_hour', 'walk_in_freezer')}
              validators={['required']}
              errorMessages={['Please enter a valid number']}
              type='number'
            />
          </td>
          <td>
            <button type='button' className='btn btn-round btn-danger' style={{wordBreak: 'normal'}} onClick={() => removeItem('walk_in_freezer', row)}>
              Remove
            </button>
          </td>
        </tr>
      )
    })
    
    const waterHeaterRows = Array.isArray(waterHeaterList) && waterHeaterList.map((row, i) => {
      return (
        <tr key={i + '_water_heater'} className={'table-default'}>
          {defaultRows('water_heater', row, i)}
          <td>
            <Fields.Input
              icon={'hashtag'}
              name='uef'
              value={row?.uef}
              className='form-control'
              onChange={ev => on.setInput(ev.target.value, i, 'uef', 'water_heater')}
              validators={['required']}
              errorMessages={['Please enter a valid number']}
              type='number'
            />
          </td>
          <td>
            <button type='button' className='btn btn-round btn-danger' style={{wordBreak: 'normal'}} onClick={() => removeItem('water_heater', row)}>
              Remove
            </button>
          </td>
        </tr>
      )
    })

    // Main HTML Generation for Modal Data
    return (
      // * AC MODEL *
      <div key={'exemption_history'} className='form-wizard-form-table table' style={{wordBreak: 'break-word', border: 'none'}}>
        <h4 className='ml-1' style={{padding: '6px', backgroundColor: '#dee7f7b5', borderRadius: '4px'}}>A/C Models</h4>
          <table className='table table-striped table-striped-bg-black'>
            {colgroup}
            {acModelHeadings}
            <tbody>
              {addItemRow('ac')}
              {acRows?.length > 0 ? acRows : emptyTableRows(5, 'ac')}
            </tbody>
          </table>
        <div className='pl-2 mb-4' style={{maxWidth: '400px', backgroundColor: '#dee7f7b5'}}>
          <label htmlFor='ac_total'>Total Quantity</label>
          <Fields.Input
            icon={'hashtag'}
            id='ac_total'
            name='air_conditioner_quantity'
            value={airConditionerQuantity}
            className='form-control'
            onChange={ev => setAirConditionerQuantity(ev.target.value)}
            // validators={['required']}
            // errorMessages={['Required']}
            type='number'
          />
        </div>
        <div className='pl-2 mb-4' style={{maxWidth: '400px', backgroundColor: '#dee7f7b5', borderRadius: '4px'}}>
          <button type='button'
            className='btn btn-round'
            style={{width: '100%'}}
            // style={{border: '1px solid lightgrey'}}
            title='Click to use Automated value for Total Quantity'
            onClick={() => setAirConditionerQuantity(calcAcQty)}
          >
            Total Qty (Automated): {calcAcQty}
          </button>
        </div>

        {/* FRIDGE MODEL */}
        <h4 className='ml-1' style={{padding: '6px', backgroundColor: '#def7f4b5', borderRadius: '4px'}}>Refrigerator Models</h4>
        <table className='table table-striped table-striped-bg-black'>
          {colgroup}
          {fridgeModelHeadings}
          <tbody>
            {addItemRow('fridge')}
            {fridgeRows?.length > 0 ? fridgeRows : emptyTableRows(5, 'fridge')}
          </tbody>
        </table>
        <div className='pl-2 mb-4' style={{maxWidth: '400px', backgroundColor: '#def7f4b5'}}>
          <label htmlFor='fridge_total'>Total Quantity</label>
          <Fields.Input
            icon={'hashtag'}
            id='fridge_total'
            name='fridge_quantity'
            value={fridgeQuantity}
            className='form-control'
            onChange={ev => setFridgeQuantity(ev.target.value)}
            // validators={['required']}
            // errorMessages={['Required']}
            type='number'
          />
        </div>
        <div className='pl-2 mb-4' style={{maxWidth: '400px', backgroundColor: '#def7f4b5', borderRadius: '4px'}}>
          <button type='button'
            className='btn btn-round'
            style={{width: '100%'}}
            // style={{border: '1px solid lightgrey'}}
            title='Click to use Automated value for Total Quantity'
            onClick={() => setFridgeQuantity(calcFridgeQty)}
          >
            Total Qty (Automated): {calcFridgeQty}
          </button>
        </div>

        {/* FREEZER MODEL */}
        <h4 className='ml-1' style={{padding: '6px', backgroundColor: '#dee7f7b5', borderRadius: '4px'}}>Freezer Models</h4>
        <table className='table table-striped table-striped-bg-black'>
          {colgroup}
          {fridgeModelHeadings}
          <tbody>
            {addItemRow('freezer')}
            {freezerRows?.length > 0 ? freezerRows : emptyTableRows(5, 'freezer')}
          </tbody>
        </table>
        <div className='pl-2 mb-4' style={{maxWidth: '400px', backgroundColor: '#dee7f7b5'}}>
          <label htmlFor='freezer_total'>Total Quantity</label>
          <Fields.Input
            icon={'hashtag'}
            id='freezer_total'
            name='freezer_quantity'
            value={freezerQuantity}
            className='form-control'
            onChange={ev => setFreezerQuantity(ev.target.value)}
            // validators={['required']}
            // errorMessages={['Required']}
            type='number'
          />
        </div>
        <div className='pl-2 mb-4' style={{maxWidth: '400px', backgroundColor: '#dee7f7b5', borderRadius: '4px'}}>
          <button type='button'
            className='btn btn-round'
            style={{width: '100%'}}
            // style={{border: '1px solid lightgrey'}}
            title='Click to use Automated value for Total Quantity'
            onClick={() => setFreezerQuantity(calcFreezerQty)}
          >
            Total Qty (Automated): {calcFreezerQty}
          </button>
        </div>

        {/* WALK-IN FRIDGE */}
        <h4 className='ml-1' style={{padding: '6px', backgroundColor: '#def7f4b5', borderRadius: '4px'}}>Walk-In Refrigerators</h4>
        <table className='table table-striped table-striped-bg-black'>
          {colgroup}
          {walkInModelHeadings}
          <tbody>
            {addItemRow('walk_in_fridge')}
            {walkInFridgeRows?.length > 0 ? walkInFridgeRows : emptyTableRows(6, 'walk_in_fridge')}
          </tbody>
        </table>
        <div className='pl-2 mb-4' style={{maxWidth: '400px', backgroundColor: '#def7f4b5'}}>
          <label htmlFor='walk_in_fridge_total'>Total Quantity</label>
          <Fields.Input
            icon={'hashtag'}
            id='walk_in_fridge_total'
            name='walk_in_fridge_quantity'
            value={walkInFridgeQuantity}
            className='form-control'
            onChange={ev => setWalkInFridgeQuantity(ev.target.value)}
            // validators={['required']}
            // errorMessages={['Required']}
            type='number'
          />
        </div>
        <div className='pl-2 mb-4' style={{maxWidth: '400px', backgroundColor: '#def7f4b5', borderRadius: '4px'}}>
          <button type='button'
            className='btn btn-round'
            style={{width: '100%'}}
            // style={{border: '1px solid lightgrey'}}
            title='Click to use Automated value for Total Quantity'
            onClick={() => setWalkInFridgeQuantity(calcWalkInFridgeQty)}
          >
            Total Qty (Automated): {calcWalkInFridgeQty}
          </button>
        </div>

        {/* WALK-IN FREEZER */}
        <h4 className='ml-1' style={{padding: '6px', backgroundColor: '#dee7f7b5', borderRadius: '4px'}}>Walk-In Freezers</h4>
        <table className='table table-striped table-striped-bg-black'>
          {colgroup}
          {walkInModelHeadings}
          <tbody>
            {addItemRow('walk_in_freezer')}
            {walkInFreezerRows?.length > 0 ? walkInFreezerRows : emptyTableRows(6, 'walk_in_freezer')}
          </tbody>
        </table>
        <div className='pl-2 mb-4' style={{maxWidth: '400px', backgroundColor: '#dee7f7b5'}}>
          <label htmlFor='walk_in_freezer_total'>Total Quantity</label>
          <Fields.Input
            icon={'hashtag'}
            id='walk_in_freezer_total'
            name='walk_in_freezer_quantity'
            value={walkInFreezerQuantity}
            className='form-control'
            onChange={ev => setWalkInFreezerQuantity(ev.target.value)}
            // validators={['required']}
            // errorMessages={['Required']}
            type='number'
          />
        </div>
        <div className='pl-2 mb-4' style={{maxWidth: '400px', backgroundColor: '#dee7f7b5', borderRadius: '4px'}}>
          <button type='button'
            className='btn btn-round'
            style={{width: '100%'}}
            // style={{border: '1px solid lightgrey'}}
            title='Click to use Automated value for Total Quantity'
            onClick={() => setWalkInFreezerQuantity(calcWalkInFreezerQty)}
          >
            Total Qty (Automated): {calcWalkInFreezerQty}
          </button>
        </div>

        {/* Water Heater */}
        <h4 className='ml-1' style={{padding: '6px', backgroundColor: '#def7f4b5', borderRadius: '4px'}}>Water Heater Models</h4>
        <table className='table table-striped table-striped-bg-black'>
          {colgroup}
          {heaterModelHeadings}
          <tbody>
            {addItemRow('water_heater')}
            {waterHeaterRows?.length > 0 ? waterHeaterRows : emptyTableRows(5, 'water_heater')}
          </tbody>
        </table>
        <div className='pl-2 mb-4' style={{maxWidth: '400px', backgroundColor: '#def7f4b5'}}>
          <label htmlFor='water_heater_total'>Total Quantity</label>
          <Fields.Input
            icon={'hashtag'}
            id='water_heater_total'
            name='water_heater_quantity'
            value={waterHeaterQuantity}
            className='form-control'
            onChange={ev => setWaterHeaterQuantity(ev.target.value)}
            // validators={['required']}
            // errorMessages={['Required']}
            type='number'
          />
        </div>
        <div className='pl-2 mb-4' style={{maxWidth: '400px', backgroundColor: '#def7f4b5', borderRadius: '4px'}}>
          <button type='button'
            className='btn btn-round'
            style={{width: '100%'}}
            // style={{border: '1px solid lightgrey'}}
            title='Click to use Automated value for Total Quantity'
            onClick={() => setWaterHeaterQuantity(calcWaterHeaterQty)}
          >
            Total Qty (Automated): {calcWaterHeaterQty}
          </button>
        </div>
      </div>
    )
  }

  return (
    <div style={{ maxWidth: '100%', width: '100%' }}>
      <div className='modal-header'>
        <h5 className='modal-title' style={{ paddingLeft: '10px', textTransform: 'capitalize' }}>
          Exemption Listing
          <br/>
          <b>{tableName}</b>
        </h5>
      </div>
        <div className='modal-body' style={{border: 'none'}}>
          <ValidatorForm id='exemption-history-items' onSubmit={formSubmit}>
            {tables()}
          </ValidatorForm>
          <br />
        </div>
      <div className='modal-footer'>
        <button className='btn btn-round mr-2' onClick={closeModal}>
          Cancel
        </button>
        <input
          className='btn custom-btn btn-round'
          form='exemption-history-items'
          type='submit'
          value='Update Exemptions'
        />
      </div>
    </div>
  )
}
  
export {
  GCExemptionModify
}
